

export const data=[

    {
        id:'018',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/China.png'),
        title: "Dragon Raja (Long Zu)",
        Cover: require("../imgs/imgs-data/Cover/Dragon Raja (Long Zu).webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Dragon Raja (Long Zu).webp"),
        teller: 'https://youtu.be/kLDDmawTgNo',
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"السبت",
        description:'لو مينغفي طالب ثانوي عادي واجه حظًا سيئًا في حياته تلقى بشكل مفاجئ خطاب قبول من كلية كاسل وهي جامعة أجنبية خاصة واجه لو مينغفي صراعًا داخليًا بين القبول أو الرفض لكنه قرر في النهاية خوض التجربة والالتحاق بالجامعة بمجرد دخوله عالم التنين تغيرت حياة لو مينغفي بشكل جذري. واجه تحديات هائلة لم يكن يتوقعها وشرع في رحلة صعبة مليئة بالمخاطر والمواقف المثيرة. رحلة قتل التنين هذه تمثل رمزًا لتحديه لصعوبات الحياة وكسر قيودها، وتحويله من شخص عادي إلى بطل حقيقي.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","مغامرات"],
        Episodes: 5,
        EpisodesTime: 24,
        Type: "رواية",
        Source: "TV",
        rating: 7.17,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'016',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Boku no Hero Academia: Memories",
        Cover: require("../imgs/imgs-data/Cover/Boku no Hero Academia Memories.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Boku no Hero Academia Memories.jpg"),
        teller: "https://youtu.be/FnolTKc55rY",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"السبت",
        description:'أربع حلقات ملخصة للمواسم الستة السابقة.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["قوة خارقة","مدرسي","أكشن","شونين"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 6.49,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'015',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:true,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Kaijuu 8-gou",
        Cover: require("../imgs/imgs-data/Cover/Kaijuu 8-gou.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Kaijuu 8-gou.jpg"),
        teller: "https://youtu.be/V0OZWzTAqHg",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"السبت",
        description:'بمعدلات ظهور كايجو الأعلى في العالم، لا تعتبر الهجمات القاتلة للوحوش على اليابان غريبةً أبدًا. يدخل في هذا السياق قوات الدفاع اليابانية، منظمة عسكرية مكلفة بالإطاحة بالكايجو. وكافكا هيبينو، الذي يعمل في تنظيف جثث الكايجو، دائما ما كان يحلم بالانضمام إلى القوات. ولكن عندما يحصل على فرصة جديدة لتحقيق حلم طفولته، يتعرض لتحول غير متوقع. كيف يمكن له محاربة الكايجو الآن بعد أن أصبح واحدًا منهم؟',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","أكشن","خيال علمي"],
        Episodes: 2,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 8.26,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'014',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "One Room, Hiatari Futsuu, Tenshi-tsuki.",
        Cover: require("../imgs/imgs-data/Cover/One Room, Hiatari Futsuu, Tenshi-tsuki..jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/One Room, Hiatari Futsuu, Tenshi-tsuki..jpg"),
        teller: "https://youtu.be/WZcTU85j6t4",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"السبت",
        description:'القصة تتحدث عن ينتارو توكوميتسو طالب الثانوي يعيش وحيداً في شقة صغيرة، لكن حياته تتغير عندما تظهر على شرفته فتاة غريبة تدَّعي أنها ملاك اسمها توا.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["كوميدي","رومانسي","خارق للطبيعة","حريم"],
        Episodes: 4,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 7.11,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'013',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "The New Gate",
        Cover: require("../imgs/imgs-data/Cover/The New Gate.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/The New Gate.jpg"),
        teller: "https://youtu.be/K_4l3EiQKEU",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"السبت",
        description:'البوابة الجديدة هي لعبة أونلاين تحولت إلى صراع حياة أو موت بين لاعبيها. بفضل الجهود الشجاعة التي بذلها شين، الأقوى منهم جميعًا، بدا أن نهاية اللعبة وتحرر الجميع قد اقترب. ولكن بعد لحظات فقط من هزيمة شين للزعيم الأخير للعبة، يجد نفسه غارقًا في ضوء مجهول وينتقل حوالي 500 عام إلى مستقبل عالم اللعبة. ليتحول الوضع من حدوث مصيبة بلعبة بسيطة إلى كارثة وصوله إلى أرض جديدة غريبة، فيشرع في رحلة أسطورية بكونه الشخص الأقوى في هذه الأرض!',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["أكشن","خيال","مغامرات"],
        Episodes: 2,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 6.70,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'012',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Tensei shitara Slime Datta Ken 3rd Season",
        Cover: require("../imgs/imgs-data/Cover/Tensei shitara Slime Datta Ken 3rd Season.webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Tensei shitara Slime Datta Ken 3rd Season.jpg"),
        teller: "https://youtu.be/HaI4kX5gkPU",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الجمعة",
        description:'الموسم الثالث من الأنمي.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["كوميدي","سحر","خيال","مغامرات","أكشن"],
        Episodes: 4,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 8.33,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'011',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Wind Breaker",
        Cover: require("../imgs/imgs-data/Cover/Wind Breaker.webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Wind Breaker.jpg"),
        teller: "https://youtu.be/62r_G9bEPlU",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الخميس",
        description:'القصة تدور في مدرسة ثانوية للجانحين الذين أصبحوا الآن أبطالًا يحمون مدينتهم ويصل طالب جديد شرس إلى المدرسة مصممًا على القتال في طريقه إلى القمة ويصبح الأقوى بينهم جميعًا.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["مدرسي","أكشن"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 7.91,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'010',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Maou no Ore ga Dorei Elf wo Yome ni Shitanda ga Dou Medereba Ii?",
        Cover: require("../imgs/imgs-data/Cover/Maou no Ore ga Dorei Elf wo Yome ni Shitanda ga, Dou Medereba Ii.webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Maou no Ore ga Dorei Elf wo Yome ni Shitanda ga, Dou Medereba Ii.jpg"),
        teller: "https://youtu.be/0vpyWrNoAz4",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الخميس",
        description:'زاغان معروف بكونه ساحرًا شريرًا وهذا هو السبب الرئيسي لخوف الكثيرين منه يتميز بعدم اجتماعيته وسوء لسانه وبالتالي يقضي أيامه في دراسة السحر والتركيز على ذلك في حين يعاقب أي شخص يتجاوز حدود أراضيه تمت دعوته يومًا ما إلى مزاد مظلم وما وجده هناك هو فتاة عبدة إلفية ذات جمال لا مثيل له نيفي.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","رومانسي","أكشن","سحر"],
        Episodes: 4,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 7.59,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'009',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:true,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/South_Korea.png'),
        title: "Kenka Dokugaku",
        Cover: require("../imgs/imgs-data/Cover/Kenka Dokugaku.webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Kenka Dokugaku.webp"),
        teller: "https://youtu.be/AEmhWfAdSQQ",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الأربعاء",
        description:'طالب المدرسة الثانوية الهزيل هو-بين يو من المحتمل أن يكون آخر شخص تتوقع أن يسطع كـ NewTube في أمور القتالات ولكن بعد اتباعه بعض النصائح يبدأ بالإطاحة بالأعداء الأقوى منه وجمع أموالًا أكثر مما كان يحلم به، لكن هل سيستمر بالانتصار دومًا أم أنه سيلتقي بنظيرهُ الذي سيُطيح بهِ في النهاية؟',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["أكشن"],
        Episodes: 2,
        EpisodesTime: 24,
        Type: "مانهوا",
        Source: "TV",
        rating: 6.91,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'008',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Unnamed Memory",
        Cover: require("../imgs/imgs-data/Cover/Unnamed Memory.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Unnamed Memory.jpg"),
        teller: "https://youtu.be/1MhIE9yVfyg",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الثلاثاء",
        description:'أمنيتي كبطل هي أن تنزلي من البرج وتصبحي زوجتي." هذه كانت كلمات أوسكار أثناء صعوده برج مميت، فقد كان يبحث عن قوة، ساحرة القمر الأزرق. إنه يأمل أن يتمكن سحرها المذهل من كسر اللعنة التي ستقتل أي امرأة يتخذها زوجة له. لكن عندما يرى الأمير مدى جمال تيناشا، تتغير الحسبة لديه بالكامل - نظرًا لأنها قوية بما يكفي للنجاة من لعنته، وجدها مناسبةً كزوجة له مع ذلك تيناشا ليست متحمسة للموضوع أبدًا، لكنها توافق على العيش مع أوسكار في القلعة الملكية لمدة عام وهي المدة التي ستبحث فيها عن التعويذة التي تم تطبيقها على الأمير. يخفي وجه الساحرة الجميل العديد من الأسرار السوداوية التي قد يدوم تأثيرها للأبد، ولكن الأسرار تبدأ في الظهور بالتدريج.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["أكشن","رومانسي","خيال"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 7.35,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'007',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Dekisokonai to Yobareta Motoeiyuu wa Jikka kara Tsuihou sareta node Sukikatte ni Ikiru Koto ni Shita",
        Cover: require("../imgs/imgs-data/Cover/Dekisokonai to Yobareta Motoeiyuu wa Jikka kara Tsuihou sareta node Sukikatte ni Ikiru Koto ni Shita.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Dekisokonai to Yobareta Motoeiyuu wa Jikka kara Tsuihou sareta node Sukikatte ni Ikiru Koto ni Shita.jpg"),
        teller: "https://youtu.be/5F1UedA_Ks0",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الإثنين",
        description:'بسبب مستواه المنخفض وعدم وجود هبة إلهية يُعتبر آلن عديم الفائدة ويُجرّد من منزلته النبيلة ونفيه من إقليم ويستفيلد لكن لدى آلن سر إنه كان بطلاً عظيمًا في حياته السابقة وهو متحمس للفرصة ليعيش أخيرًا بالطريقة التي يرغب فيها! ومع ذلك تتعكر حياته الخالية من الدراما قريبًا بسبب لقاءٍ',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","أكشن","مغامرات"],
        Episodes: 5,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 5.09,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'006',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Lv2 kara Cheat datta Motoyuusha Kouho no Mattari Isekai Life",
        Cover: require("../imgs/imgs-data/Cover/Lv2 kara Cheat datta Motoyuusha Kouho no Mattari Isekai Life.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Lv2 kara Cheat datta Motoyuusha Kouho no Mattari Isekai Life.jpg"),
        teller: "https://youtu.be/yCwlJA8d_5k",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الإثنين",
        description:'تستدعي مملكة كليرود السحرية مئات الأبطال من عوالم أخرى كل عام للقتال في حربهم ضد الظالم وجيشه من الشياطين الأقوياء بانازا هو أحد هؤلاء الأبطال تم استدعاؤه من العاصمة الملكية بالوما لكن شيئًا ما ليس كما ينبغي بانازا مجرد تاجر عادي ليس لديه سحر ولا قدرة قتالية وحالته السحرية سيئة للغاية والأسوأ من ذلك أن حادثًا مؤسفًا يتركه غير قادر على العودة إلى مسقط رأسه! بعدما رُفض كبطل وتقطعت به السبل في عالم آخر وتُرك خارج المملكة من قبل ملك قاسي يرغب برحيله فقط يظهر لنا أن قدر بانازا سوداوي للغاية ولكن ماذا سيحدث عندما يجد المرشح للبطولة الفاشل هذا نفسه متمتعًا بقدرات الغش بمجرد وصوله إلى المستوى الثاني؟',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["مغامرات","رومانسي","خيال "],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 7.05,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'005',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Tensei shitara Dainana Ouji Datta node, Kimama ni Majutsu wo Kiwamemasu",
        Cover: require("../imgs/imgs-data/Cover/Tensei shitara Dainana Ouji Datta node, Kimama ni Majutsu wo Kiwamemasu.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Tensei shitara Dainana Ouji Datta node, Kimama ni Majutsu wo Kiwamemasu.jpg"),
        teller: "https://youtu.be/Wed_lvQxQM0",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الإثنين",
        description:'لم يكن الأمير لويد دائمًا أميرًا في الواقع حياته السابقة هي حياة يتذكرها تمامًا لقد كان ساحرًا من نوع ما لذلك عندما أُجبر على التجسد قرر مواصلة دراسة السحر لكن حياته الجديدة لها مجموعاتها الخاصة من التحديات بما في ذلك أن يكون في العاشرة من عمره ماذا سيفعل الأمير الساحر السابع.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","أكشن","سحر"],
        Episodes: 4,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 6.91,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'004',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:true,
        topCommon: true,                                               
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Re:Monster",
        Cover: require("../imgs/imgs-data/Cover/ReMonster.webp"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/ReMonster.jpg"),
        teller: "https://youtu.be/7ssm4nUotV8",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الإثنين",
        description:'تم إعادة تجسيد توموكوي كاناتا في أضعف العفاريت غوبلين والذي يُدعى غوبورو بعد أن تعرض لموت مؤسف ومع ذلك استطاع غوبورو الاحتفاظ بذكريات حياته السابقة وحصل على تطور غير عادي بالإضافة إلى أنه أصبح قويًا بما فيه الكفاية للحصول على زيادات في قدراته من خلال أكل مخلوقات أخرى ليحصل على قوتهم.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","أكشن","مغامرات"],
        Episodes: 4,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 7.13,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'003',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:true,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Mushoku Tensei II: Isekai Ittara Honki Dasu Part 2",
        Cover: require("../imgs/imgs-data/Cover/Mushoku Tensei II Isekai Ittara Honki Dasu Part 2.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Mushoku Tensei II Isekai Ittara Honki Dasu Part 2.jpg"),
        teller: "https://youtu.be/zZ_6WX9OZcA",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الأحد",
        description:'القسم الثاني من الموسم الثاني.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["دراما","خيال","مغامرات","سحر"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 8.36,
        Release:"2024",
        age: true,
        seasons: false,
        },
    },
    {
        id:'002',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:false,
        topCommon: false,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Jiisan Baasan Wakagaeru",
        Cover: require("../imgs/imgs-data/Cover/Jiisan Baasan Wakagaeru.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Jiisan Baasan Wakagaeru.webp"),
        teller: "https://youtu.be/IUcyRm7Ox30",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الأحد",
        description:'عجوزان (الجد والجدة) لسبب ما يعودان لشبابهما، فكيف سيتأقلم أبنائهما وأحفادهما وما السر خلف هذا بالضبط؟',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["كوميدي","رومانسي","خارق للطبيعة"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "مانجا",
        Source: "TV",
        rating: 7.11,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
        id:'001',
        page: {
        addRecently:true,
        top: false,
        topMainCard:false,
        forYou:true,
        topCommon: true,
        flag:require('../imgs/imgs-data/flag/Japan.png'),
        title: "Tensei Kizoku, Kantei Skill de Nariagaru",
        Cover: require("../imgs/imgs-data/Cover/Tensei Kizoku, Kantei Skill de Nariagaru.jpg"),
        backgroundCover: require("../imgs/imgs-data/backgroundCover/Tensei Kizoku, Kantei Skill de Nariagaru.png"),
        teller: "https://youtu.be/aLVEDAJx4uI",
        EpisodeData:{
            video:[
            {
                idServer:1,
                name:"mega",
                imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
            },
            {
                idServer:2,
                name:"Google Drive",
                imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
            }
            ],
            download:[
                {
                    idServer:1,
                    name:"mega",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                },
                {
                    idServer:3,
                    name:"mediafire",
                    imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                    ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                
                },
                {
                    idServer:4,
                    name:"تحميل مباشر",
                    imgServerDownload:"",
                    ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                },
            ]
        },
        EpisodeTime:"الأحد",
        description:'بعد إعادة تجسيده، من المفترض أن يعيش آرس لوفينت في عالم مختلف كأرستقراطي ضعيف. كانت قوته البدنية وذكائه متوسطين في كلا العالمين، لكنه هنا يمتلك بطبيعة الحال مهارة تسمى "التقييم". والتي تُمكنه من رؤية إمكانات أي شخص. وهكذا من خلال جمع الأشخاص الموهوبين إلى جانبه، يستخدم آرس مهارة "التقييم" هذه لتحويل منطقته الضعيفة إلى المنطقة الأقوى! لكن الطريق أمامه لن يكون بهذه البساطة، لأن هناك جميع أنواع التحديات التي تنتظرهُ من بينها خسارة من يعزهم ويحبهم.',
        state: "يعرض الان",
        stateColor: "#13a942",
        category: ["خيال","مغامرات"],
        Episodes: 3,
        EpisodesTime: 24,
        Type: "رواية خفيفة",
        Source: "TV",
        rating: 7.10,
        Release:"2024",
        age: false,
        seasons: false,
        },
    },
    {
                id: 1,
                page: {
                addRecently:false,
                top: false,
                topMainCard:false,
                forYou:true,
                topCommon: false,
                flag:require('../imgs/imgs-data/flag/Japan.png'),
                title: "Bleach part3",
                Cover: require("../imgs/imgs-data/Cover/Bleach part3.webp"),
                backgroundCover: require("../imgs/imgs-data/backgroundCover/BLEACH 3.jpg"),
                teller: "https://youtu.be/7opd_2MbJMw",
                EpisodeData:{
                    video:[
                    ],
                    download:[
                    ]
                },
                EpisodeTime:"",
                description: 'القسم الثالث من الموسم الثاني',
                state: "لم يتم بثه بعد",
                stateColor: "#ffff",
                category: ["أكشن","شونين","مغامرات","خيال"],
                Episodes: 0,
                EpisodesTime: 23,
                Type: "منجا",
                Source: "TV",
                rating: 0,
                Release:"2024",
                age: true,
                seasons: false,
                },
            },
            {
                id: 2,
                page: {
                    addRecently:true,
                top: false,
                forYou:false,
                topMainCard:false,
                topCommon: false,
                flag:require('../imgs/imgs-data/flag/Japan.png'),
                title: "Bleach: Sennen Kessen-hen - Ketsubetsu-tan",
                Cover: require("../imgs/imgs-data/Cover/Bleach part2.jpg"),
                backgroundCover: require("../imgs/imgs-data/backgroundCover/BLEACH 2.jpg"),
                teller: "https://youtu.be/53_QT4NSB48",
                EpisodeData:{
                    video:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                    }
                    ],
                    download:[
                        {
                            idServer:1,
                            name:"mega",
                            imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                            ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                        },
                        {
                            idServer:2,
                            name:"Google Drive",
                            imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                            ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                        },
                        {
                            idServer:3,
                            name:"mediafire",
                            imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                            ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                        
                        },
                        {
                            idServer:4,
                            name:"تحميل مباشر",
                            imgServerDownload:"",
                            ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                        },
                    ]
                },
                EpisodeTime:"",
                description: 'القسم الثاني من الموسم الثاني.',
                state: "مكتمل",
                stateColor: "red",
                category: ["أكشن","شونين","مغامرات","خيال"],
                Episodes: 12,
                EpisodesTime: 23,
                Type: "منجا",
                Source: "TV",
                rating: 9.0,
                Release:"2023",
                age: true,
                seasons: false,
                },
            },
        {
            id: 3,
            page: {
                addRecently:true,
            top: true,
            topMainCard:true,
            forYou:false,
            topCommon: true,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Bleach: Thousand Year Blood War",
            Cover: require("../imgs/imgs-data/Cover/Bleach Thousand Year Blood War.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Bleach .gif"),
            teller: "https://youtu.be/78WIYzX_m98",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأحد",
            description: "القسم الأول من الموسم الثاني. -تتمة أحداث انمي Bleach “كوروساكي ايشيغو” طالب ثانوية عادي، إلى أن يتم مهاجمة عائلته من قبل “أجوف”، وهي روح فاسدة تسعى إلى التهام أرواح البشر.يلتقي بحاصدة أرواح تدعى “كوشيكي روكيا”، والتي تصاب أثناء حماية عائلة “ايشيغو”.لإنقاذهم، يقبل “ايشيغو” عرض “روكيا” بأخذ قدرتها، ليصبح أيضا حاصد أرواح ولكن ، نظرًا لأن “روكيا” غير قادرة على استعادة قدرتها، يكلَّف “ايشيغو” بمهمة صعبة متمثلة في تعقب الـ“أجوف” الذي يهدد بلدته. لاحقا، انضم إليه أصدقاؤه، ولم يعد وحيدا في معركته، وهم زملاءه في الدراسة الذين يمتلكون أيضا قدرات فريدة.مع اعتياد “ايشيغو” ورفاقه على واجباتهم الجديدة، ويبدأون بدعم بعضهم البعض داخل وخارج ساحة المعركة. سرعان ما يكتشف حاصد الأرواح الشاب أن الـ“أجوف” ليس التهديد الحقيقي الوحيد للعالم البشري.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن", "مغامرات", "قوة خارقة", "شونين", "خارق للطبيعة"],
            Episodes: 13,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 9.0,
            Release:"2022",
            age: true,
            seasons: false,
            },
        },
        {
            id: 4,
            page: {
                addRecently:true,
            top: true,
            topMainCard:false,
            forYou:false,
            topCommon: true,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "one piece",
            Cover: require("../imgs/imgs-data/Cover/one piece.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/one-piece-luffy.gif"),
            teller: "https://youtu.be/MCb13lbVGE0",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأحد",
            description:"لعظمة , المجد , الذهب , مزايا اشتملت عليها حياة ملك القراصنة غولد روجر الذي حكم عليه بالإعدام لأسباب مجهولة, و ارتأى أن يشي بسر كنزه المعروف بـ ” ون بيس” و المخبأ في مكان ما على الخط الكبير قبل أن ينفذ فيه حكم الإعدام. و بعد اثنين و عشرين سنة من هذه الحادثة تبدأ أحداث قصتنا , و يظهر بطلنا القرصان مونكي دي لوفي الحالم بالعثور على الكنزو الطامع بلقب ملك القراصنة , و من أجل ذلك , يقوم بتناول فاكهة الشيطان للحصول على القوة اللازمة و لتيسير و تذييل العقبات التي من شأنها إعاقة المهمة. و قبل البدء بأي شيء , عليه أولاً أن يجد الطاقم المناسب ليبدءون رحلة البحث عن الكنز الأسطوري.",
            state: "يعرض الان",
            stateColor: "#13a942",
            category: ["كوميدي","دراما","خيال","أكشن","مغامرات","قوة خارقة","شونين"],
            Episodes: 1097,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 9.0,
            Release:"1999",
            age: false,
            seasons: false,
            },
        },
        {
            id: 5,
            page: {
                addRecently:true,
            top: true,
            topMainCard:false,
            forYou:true,
            topCommon: true,
            flag:require('../imgs/imgs-data/flag/South_Korea.png'),
            title: "Solo Leveling",
            Cover: require("../imgs/imgs-data/Cover/Solo Leveling.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Solo Leveling.webp"),
            teller: "https://youtu.be/eqy85AL70PU",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"السبت",
            description: "منذ 10 سنوات بدأت بوابات غامضة تطهر ضمن أنحاء العالم وهذه البوابات تحوي بداخلها وحوش لذلك يجب على الصيادين الذين حصلو على قوى غامضة الدخول للبوابات والقضاء على الوحوش قبل أن تخرج إلى العالم و تنشر الفساد والرعب في الأرض ويأتي بطل القصة سونغ جين وو وهو معروف بأنه أضعف صياد في العالم من المرتبة e إلى إحدى البوابات الغامضة حيث قبل لسونغ ومن معه بأن الوحوش التي في داخل البوابة مستواها ضعيف و يستطيعون القضاء عليهم لكن سونغ والصيادين دخلو إلى غرفة غامضة.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","خيال","مغامرات"],
            Episodes: 12,
            EpisodesTime:23,
            Type: "مانهوا",
            Source: "TV",
            rating: 8.5,
            Release:"2024",
            age: true,
            seasons: false,
            },
        },
        {
            id: 6,
            page: {
                addRecently:true,
            top: false,
            forYou:false,
            topMainCard:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Hunter X Hunter",
            Cover: require("../imgs/imgs-data/Cover/Hunter X Hunter.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Hunter X Hunter.jpg"),
            teller: "https://youtu.be/d6kBeJjTGnY",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الخميس",
            description: "منذ 10 سنوات بدأت بوابات غامضة تطهر ضمن أنحاء العالم وهذه البوابات تحوي بداخلها وحوش لذلك يجب على الصيادين الذين حصلو على قوى غامضة الدخول للبوابات والقضاء على الوحوش قبل أن تخرج إلى العالم و تنشر الفساد والرعب في الأرض ويأتي بطل القصة سونغ جين وو وهو معروف بأنه أضعف صياد في العالم من المرتبة e إلى إحدى البوابات الغامضة حيث قبل لسونغ ومن معه بأن الوحوش التي في داخل البوابة مستواها ضعيف و يستطيعون القضاء عليهم لكن سونغ والصيادين دخلو إلى غرفة غامضة.",
            state: "متوقف",
            stateColor: "#c67409",
            category: ["أكشن","خيال","مغامرات"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.5,
            Release:"2011",
            age:true,
            seasons: false,
            },
        },
        {
            id: 7,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:true,
            topCommon: true,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Black Clover",
            Cover: require("../imgs/imgs-data/Cover/Black Clover .jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Black Clover .jpg"),
            teller: "https://youtu.be/QwNWY6z93O4",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"السبت",
            description: "القصة تدور حول أستا ويونو الذين تم التخلي عنهما معا في نفس الكنيسة وكانا لا ينفصلان منذ ذلك الحين. وباعتبارهم أطفالا، وعدوا بأنهم سيتنافسون مع بعضهم البعض لمعرفة من سيصبح الإمبراطور المقبل ماجوس. ومع ذلك، عندما كبرا، أصبحت بعض الاختلافات بينهما واضحة. كان يونو عبقريا مع السحر، مع قوة وسيطرة مذهلين، في حين أن أستا لا يمكنه استخدام السحر على الإطلاق، وحاول تعويض عن نقصه من خلال التدريب جسديا.ومع انطلاق بطولة “جريمويري” ستبدأ الرحلة المليئة بالمغامرات والأكشن.",
            state: "متوقف",
            stateColor: "#c67409",
            category: ["شونين","خيال","كوميدي","سحر","كوميدي","أكشن"],
            Episodes: 170,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.2,
            Release:"2017",
            age: true,
            seasons: false,
            },
        },
        {
            id: 8,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Attack On Titan Anime the final season",
            Cover: require("../imgs/imgs-data/Cover/Attack On Titan Anime the final season.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Attack On Titan .jpg"),
            teller: "https://youtu.be/M_OauHnAFc8",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الخميس",
            description: "قصة أنمي Shingeki no Kyojin The Final Season تأتي إستكمالا لأحداث المواسم السابقة. ",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","قوى خارقة","شونين","فنتازيا","دراما","غموض","حربي"],
            Episodes: 16,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 9.4,
            Release:"2023",
            age: true,
            seasons: false,
            },
        },
        {
            id: 9,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Chainsaw Man",
            Cover: require("../imgs/imgs-data/Cover/Chainsaw Man.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Chainsaw Man.jpg"),
            teller: "https://youtu.be/l96zmDlWCBk",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الجمعة",
            description: 'قصة انمي Chainsaw Man "رجل المنشار" في عالم مليئ بالشياطين و البشر يوجد فتى اسمه دينجي ويدعى ب رجل المنشار والذي يعمل لدى عصابة ياكوزا ليسدد ديون ابيه السابقة ولكن تغدر فيه العاصبة وتقتله ولكن يعود دينجي للحياة وتتغير حياة دينجي البائسة بعد إندماجه مع حيوانه الأليف “كلب المنشار المسمّى بوتشيتا”, والآن فهو يعيش في مدينة كبيرة كصائد شياطين رسمي, ولكن هناك الكثير ليتعلمه بشأن وظيفته الجديدة وقوة المنشار.',
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","خارق للعادة","شياطين","شونين"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.3,
            Release:"2022",
            age: true,
            seasons: false,
            },
        },
        {
            id: 10,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Goku Dragon Ball Z",
            Cover: require("../imgs/imgs-data/Cover/Goku Dragon Ball Z .webp"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Goku Dragon Ball Z .jpg"),
            teller: "https://youtu.be/sxufB6DxXk0",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الجمعة",
            description: "دراغون بول كاي هو عبارة عن تجديد لحلقات دراغون بول زد وسيتم حذف لقطات وحلقات الفيلر وأيضاً سيتم تطوير الجودة إلى HD، أي عالية الجودة.\r\nتبدأ القصة بوصول السايان غوكو إلى كوكب الأرض بعد أن تم إرساله من كوكب الأمير فيجيتا والذي يدعى بكوكب السايان. عندما يصل بطلنا غوكو إلى الأرض يسقط في أحد الأنهار بالصدفة يقابله عجوز كبير في السن يدعى سان جوهان من أهل الأرض، ويُعجب بغوكو كثيراً ويقرر أن يقوم بتربيته. تربى غوكو على يده ووجد صديقاً حميماً له يدعى كيلان, ومن هنا يبدأ انمي دراجون بول بداية قويه حين أصبح غوكو يافعاً وقوياً يدافع عن أهالي الأرض ويقاتل الأشرار الذين يأتون من كواكب مختلفة.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","شونين","مغامرات","قوى خارقة","فنون قتالية","فنتازيا","كوميدي"],
            Episodes: 98,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.3,
            age: false,
            Release:"1989",
            seasons: false,
            },
        },
        {
            id: 11,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Blue Lock",
            Cover: require("../imgs/imgs-data/Cover/Blue Lock.webp"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Blue Lock.gif"),
            teller: "https://youtu.be/oXZJ7CYshzc",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأربعاء",
            description: 'قصة انمي Blue Lock "بلو لوك" بعد التفكير في الوضع الحالي لكرة القدم اليابانية قرر الاتحاد الياباني لكرة القدم تعيين المدرب الغامض والغريب الأطوار ايغو جينباشي لتحقيق حلمهم بالفوز بكأس العالم اعتقادًا منه بأن اليابان تفتقر إلى مهاجم أناني متعطش للأهداف بدأ جينباشي إنشاء بلو لوك (قفل أزرق) منشأة تشبه السجن حيث يتم عزل 300 مهاجم موهوب من المدارس الثانوية في جميع أنحاء اليابان ويتنافسون ضد بعضهم البعض الناجي الوحيد من بلو لوك سيكسب الحق في أن يصبح مهاجم المنتخب الوطني.',
            state: "مكتمل",
            stateColor: "red",
            category: ["شونين","رياضي"],
            Episodes: 28,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.2,
            Release:"2022",
            age: false,
            seasons: false,
            },
        },
        {
            id: 12,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:true,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Death Note",
            Cover: require("../imgs/imgs-data/Cover/Death Note.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Death Note.jpg"),
            teller: "https://youtu.be/NlJZ-YgAt-c",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأربعاء",
            description: "قصة انمي Death Note تدور حول الطالب المجتهد ياجامي الذي صادف و ان التقط مذكرة الموت التي رميت من آله الموت ريكو ، كلاهما يشعر بالظجر من العالم الذي يعيشه فقرر ريكو رمي مذكرة الموت إلى عالم البشر و معرفة مالذي سيحد ، وبعدها التقطها ياكامي في الاول كان متردد في التقاطها ظننا منه ان دلك مجرد خيال الاطفال لكن فظوله اخده لالتقاطها ومعرفة ما الدي تحتويه.",
            state: "مكتمل",
            stateColor: "red",
            category: ["بوليسي","شونين","غموض","نفسي","اثارة","خارق للعادة"],
            Episodes: 37,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.9,
            Release:"2006",
            age: true,
            seasons: false,
            },
        },
        {
            id: 13,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:true,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Tokyo Ghoul",
            Cover: require("../imgs/imgs-data/Cover/Tokyo Ghoul.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Tokyo Ghoul.png"),
            teller: "https://youtu.be/vGuQeQsoRgU",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"السبت",
            description: "قصة انمي Tokyo Ghoul تدور احداثها في طوكيو المظلمة والمرعبة حيث تضهر غيلان وتقوم بمهاجمة البشر وأكل لحمهم، البشر بطبيعتهم يخافون الغيلان بسبب عدم معرفتهم لها جيدا، كين الفتى الجامعي الذي يحب القرأة وفي ظروف غامضة يتحول كين الى نصف غول ونصف بشري، فما الذي وقع مع كين ياترى ؟؟ وما الذي سوف يفعله مع هذه الهيئة الجديدة!؟!",
            state: "مكتمل",
            stateColor: "red",
            category: ["سينين","أكشن","غموض","رعب","نفسي","خارق للطبيعة","دراما"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.7,
            Release:"2014",
            age: true,
            seasons: false,
            },
        },
        {
            id: 14,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Naruto: Shippuden",
            Cover: require("../imgs/imgs-data/Cover/Naruto Shippuden.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Naruto Shippuden.jpg"),
            teller: "https://youtu.be/22R0j8UKRzY",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الثلاثاء",
            description: "قصة انمي Naruto: Shippuuden بعد مرور عامان ونصف منذ غادر ناروتو اوزوماكي قرية الورق المخفية كونوها للتدريب المكثف بسبب الأحداث التي حفزت رغبته في أن يصبح أقوى الآن الـ“اكاتسوكي وهي منظمة غامضة لنخبة النينجا الأشرار تقترب من خطتها الكبرى التي قد تهدد سلامة عالم الـشينوبي بأكمله.",
            state: "مكتمل",
            stateColor: "red",
            category: ["كوميدي","فنون قتالية","أكشن","شونين","مغامرات","قوى خارقة"],
            Episodes: 500,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.7,
            Release:"2007",
            age: false,
            seasons: false,
            },
        },
        {
            id: 15,
            page: {
                addRecently:true,
            top: false,
            forYou:false,
            topMainCard:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Dosanko Gal wa Namara Menkoi",
            Cover: require("../imgs/imgs-data/Cover/Dosanko-Gal-wa-Namara-Menkoi.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Dosanko-Gal-wa-Namara-Menkoi.jpg"),
            teller: "https://youtu.be/AwY-j4ZV570",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الثلاثاء",
            description: "ينتقل تلميذ الثانوية “تسوباسا” إلى مدينة “كيتامي” في “هوكايدو“، حيث يلتقي بـ «فتاة» في محطة للحافلات. منظرها يلتقط قلبه، وهي تقف بمفردها مقابل مشهد الثلج الأبيض، عارية الأرجل على الرغم من البرد القارس.",
            state: "مكتمل",
            stateColor: "red",
            category: ["مدرسي","شونين","رومانسي","كوميدي"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 6.9,
            Release:"2024",
            age: true,
            seasons: false,
            },
        },
        {
            id: 16,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Jujutsu Kaisen",
            Cover: require("../imgs/imgs-data/Cover/Jujutsu Kaisen.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Jujutsu Kaisen.jpg"),
            teller: "https://youtu.be/pkKu9hLT-t8",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"السبت",
            description: "القصة تتحدث عن إيتادوري يوجي و هو فتى عبقري ذو بنية جسدية قوية ويتسكع مع نادي الظواهر الخارقة في المدرسة. ذات يوم تتغير حياة يوجي بعد وفاة جده ومقابلته لميغومي فوشيغورو الذي أخبره بأنه يمتلك غرضًا ملعونًا، عندها تتوالى المصائب على يوجي.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","شونين","مدرسي","خارق للطبيعة","شياطين","رعب"],
            Episodes: 24,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.6,
            Release:"2020",
            age: true,
            seasons: false,
            },
        },
        {
            id: 17,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Mashle Part 2",
            Cover: require("../imgs/imgs-data/Cover/Mashle-2nd-Season-.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/mashle-season-2.webp"),
            teller: "https://youtu.be/b_2i_1ZgFro",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأربعاء",
            description: "القسم الثاني من الموسم الأول.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","كوميدي","خيال","مدرسي","سحر","ساخر"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.6,
            Release:"2024",
            age: false,
            seasons: false,
            },
        },
        
        {
            id: 18,
            page: {
                addRecently:false,
            top: false,
            topMainCard:false,
            forYou:true,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Boku no Hero Academia 7th Season",
            Cover: require("../imgs/imgs-data/Cover/My Hero Academia s7.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/My Hero Academia .gif"),
            teller: "https://youtu.be/msRZ0SB2xM8",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأربعاء",
            description: "بفضل تحالفها غير المتوقع مع جبهة تحرير الكليات شبه البشرية، أصبحت الرابطة تهديدًا حقيقيًا على الصعيد الوطني. الصقور، الذين ما زالوا يتسللون إلى المنظمة، يشعرون أنه يجري التحضير لعمل كبير.",
            state: "لم يتم بثه بعد",
            stateColor: "#ffff",
            category: ["أكشن","شونين","قوة خارقة","مدرسي"],
            Episodes: 0,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 0,
            Release:"2024",
            age: false,
            seasons: false,
            },
        },
        {
            id: 19,
            page: {
                addRecently:true,
            top: false,
            forYou:false,
            topMainCard:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Tsuki ga michibiku isekai-dôchû",
            Cover: require("../imgs/imgs-data/Cover/Tsuki-ga-Michibiku-Isekai-Douchuu-2nd-Season.png"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/Tsuki ga michibiku isekai-dôchû.jpg"),
            teller: "https://youtu.be/enc7VpZYpwQ",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الإثنين",
            description: "القسم الثاني من الموسم الأول.",
            state: "يعرض الان",
            stateColor: "#13a942",
            category: ["أكشن","كوميدي","خيال","مدرسي","سحر","مغامرات"],
            Episodes: 25,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.6,
            Release:"2024",
            age: true,
            seasons: false,
            },
        },
        {
            id: 20,
            page: {
                addRecently:true,
            top: false,
            topMainCard:false,
            forYou:false,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Demon Slayer: Kimetsu no Yaiba",
            Cover: require("../imgs/imgs-data/Cover/does Demon Slayer .jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/does Demon Slayer .jpg"),
            teller: "https://youtu.be/VQGCKyvzIM4",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/Ne9BDb6L#MnWHzCiYQHnQMCzk0gNu1bIwEppZGdx0wUSBM3yWt0M",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1nfPVDcSbZNwKtNUntl4IXu66jdXV7xga/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/Ne9BDb6L#MnWHzCiYQHnQMCzk0gNu1bIwEppZGdx0wUSBM3yWt0M",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1nfPVDcSbZNwKtNUntl4IXu66jdXV7xga/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/czynucqs8qy77sh/THIS_IS_4K_ANIME_%2528Tanjiro_Kamado%2529.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"الأربعاء",
            description: "إنّها حقبة تايشو في اليابان. يجد تانجيرو، الفتى الطّيّب الّذي يبيع الفحم لكسب قوت العيش، عائلته كلّها مذبوحة على يد شيطان. ولزيادة الطّين بلّة، أخته الأصغر منه نيزوكو والنّاجية الوحيدة قد تحوّلت إلى شيطانة أيضًا.",
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","خيال","شونين"],
            Episodes: 12,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 7.6,
            Release:"2020",
            age: true,
            seasons: false,
            },
        },
        {
            id: 21,
            page: {
            addRecently:true,
            top: false,
            topMainCard:false,
            forYou:true,
            topCommon: false,
            flag:require('../imgs/imgs-data/flag/Japan.png'),
            title: "Bleach",
            Cover: require("../imgs/imgs-data/Cover/Bleach 2004.jpg"),
            backgroundCover: require("../imgs/imgs-data/backgroundCover/bleach 1.webp"),
            teller: "https://youtu.be/mnFXQUq-7ks",
            EpisodeData:{
                video:[
                {
                    idServer:1,
                    name:"mega",
                    imgServer:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                    Server:"https://mega.nz/embed/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                },
                {
                    idServer:2,
                    name:"Google Drive",
                    imgServer:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                    Server:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/preview",
                }
                ],
                download:[
                    {
                        idServer:1,
                        name:"mega",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/01_mega_logo.svg.png'),
                        ServerDownload:"https://mega.nz/file/tDtC3YZb#XVJJsJSalF0vgmYdq77FW-AYhhNTIVD2xjNfp2YEJ3k",
                    },
                    {
                        idServer:2,
                        name:"Google Drive",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/Google_Drive_-_New_Logo.png'),
                        ServerDownload:"https://drive.google.com/file/d/1YmxU8TMplrGV28vQex-fUjUVKXHFZTET/view?usp=drive_link",
                    },
                    {
                        idServer:3,
                        name:"mediafire",
                        imgServerDownload:require('../imgs/imgs-data/Servers img/mediafire.png'),
                        ServerDownload:"https://www.mediafire.com/file/zz1flpjysyzvybg/_Anime4up.com__OP_EP_01_FHD__1080p_40_source__41__.mp4/file",
                    
                    },
                    {
                        idServer:4,
                        name:"تحميل مباشر",
                        imgServerDownload:"",
                        ServerDownload:require("../video/THIS IS 4K ANIME (Tanjiro Kamado).mp4"),
                    },
                ]
            },
            EpisodeTime:"السبت",
            description: 'القصة تدور حول كوروساكي إتشيجو وهو فتى في الخامسة عشر من عمره يمتلك القدرة على رؤية الأرواح/الأشباح وبسبب هذه القدرة تمكّن من لقاء شينجامي أنثى تُدعى كوتشيكي روكيا لإنقاذ عائلته من أرواح شريرة تُدعى الهولو.',
            state: "مكتمل",
            stateColor: "red",
            category: ["أكشن","شونين","مغامرات","خيال"],
            Episodes: 366,
            EpisodesTime: 23,
            Type: "منجا",
            Source: "TV",
            rating: 8.2,
            Release:"2004",
            age: false,
            seasons: false,
            },
        },
        
];










